<script setup lang="ts">
import { FilterOptions, NamespaceModel, SelectedFilterOptions } from '../../models';
import { computed, PropType, ref, watch } from 'vue';
import { OptionFilterEnum } from './enums';
import OptionItemFilter from './components/OptionItemFilter.vue';
import { OptionItemModel } from './models';
import { ProjectModel } from '@/models';
import { TagModel } from '@/components/task-forms/models';
import { TypeModel } from '@/pages/namespace-types-settings-page/models';
import { GetDifficultyListItemDetail, ProjectQueueTaskListItem } from '../../adapter';
import { useRouter } from 'vue-router';
import { TirPmButton, TirPmButtonSizeEnum, TirPmButtonVariantEnum } from 'tir-components';

/**Параметры */
const props = defineProps({
  /**Поле поиска */
  searchField: {
    type: String,
  },
  /**Применен фильтр */
  isApplyFilter: {
    type: Boolean,
  },
  /**Опции фильтра */
  filterOptions: {
    type: Object as PropType<FilterOptions>,
  },
  /**Выбранные элементы фильтра */
  selectedOptionsFilter: {
    type: Object as PropType<SelectedFilterOptions>,
  },
  /**Предыдущие значения фильтра*/
  previousFilterValues: {
    type: Object as PropType<SelectedFilterOptions>,
  },
  /**Не активна кнопка отмены фильтра */
  isDisabledCancelFilter: {
    type: Boolean,
  },
  /**изменился фильтр */
  isChangeGlobalStatus: {
    type: Boolean,
  },
  isChange: {
    type: Boolean,
  },
  /**опции фильтра которые не показывать */
  hidedOptionsFilter: {
    type: Array as PropType<OptionFilterEnum[]>,
  },
  /**показать только где я админ для проектов точно, для областей, для очередей ...' */
  showOnlyCurrentIsAdmin: {
    type: Boolean,
    required: false,
    default: true,
  },
});
/**События */
const emit = defineEmits<{
  /**Переключение чекбокса элемента*/
  toggleItem: [item: OptionItemModel, type: OptionFilterEnum, isMultiSelect: boolean];
  /**Выбрать все элементы */
  selectAllElements: [type: OptionFilterEnum, isMultiSelect: boolean];
  /**Получить ширину блока выбранных элементов */
  getWidthBlockSelectedElem: [count: number];
  /**Поиск элементов фильтра */
  searchElements: [value: string, option: OptionFilterEnum];
  /**Прокрут скрола до конца */
  scrollFinished: [type: OptionFilterEnum];
  /**Получить проекты */
  getProjects: [data: OptionItemModel[]];
  /**Получить теги проекта */
  getTagsProject: [tags: TagModel[]];
  /**Получить НС проекта */
  getNamespacesProject: [namespaces: OptionItemModel[]];
  /**Получить тип НС */
  getTypesNamespace: [types: TypeModel[]];
  /**Получить сложности */
  getDifficultys: [difficulty: OptionItemModel[]];
  /**Получить очереди */
  getQueues: [queue: ProjectQueueTaskListItem[]];
  /**Получить статусы */
  getStatuses: [statuses: OptionItemModel[], isGlobalStatusChanged?: boolean];
  /**Получить приоритеты */
  getPriorities: [priorities: OptionItemModel[]];
  /**Установить значения для предыдущих данных пункта фильтра */
  setPreviousFilterValues: [
    previousSelectedFilterValues: SelectedFilterOptions,
    previousfilterOptions: FilterOptions,
  ];

  /**Отмена изменений в фильтре */
  cancelChangesFilter: [];
  /**Сбросить фильтр */
  resetFilter: [];
}>();

/**Был ли сброше фильтр */
const isResetFilter = ref(false);
/**Доступные фильтры при выборе проекта */
const availableFiltersProject = computed(() => {
  return props.selectedOptionsFilter.Projects.some((p) => p.Id !== 0)
    ? [OptionFilterEnum.Tags, OptionFilterEnum.Namespaces]
    : [];
});
/**Доступные фильтры при выборе НС */
const availableFiltersNamespace = computed(() => {
  return props.selectedOptionsFilter.Namespaces.some((p) => p.Id !== 0)
    ? [OptionFilterEnum.Types, OptionFilterEnum.Difficultys, OptionFilterEnum.Queues]
    : [];
});
/**Доступные фильтры при выборе очереди */
const availableFiltersQueue = computed(() => {
  return props.selectedOptionsFilter.Queues.some((p) => p.Id !== 0)
    ? [OptionFilterEnum.Statuses, OptionFilterEnum.Priorities]
    : [];
});
/**Опции */
const options = computed(() => {
  const computedOptions = [
    OptionFilterEnum.GlobalStatuses,
    OptionFilterEnum.Projects,
    ...availableFiltersProject.value,
    ...availableFiltersNamespace.value,
    ...availableFiltersQueue.value,
  ];

  return computedOptions.filter((option) => option !== null);
});
/**Не активное состояние кнопки Применить */
const isDisabledApply = computed(() => {
  const areArraysEqualById = (
    a: { Id: number | string }[] = [],
    b: { Id: number | string }[] = [],
  ) => a.length === b.length && a.every((itemA) => b.some((itemB) => itemA.Id === itemB.Id));

  const queuesChanged = !props.selectedOptionsFilter.Queues?.some((queue) => queue.Id);

  const allUnchanged = Object.values(OptionFilterEnum).every((key) =>
    areArraysEqualById(props.previousFilterValues[key], props.selectedOptionsFilter[key]),
  );
  return (
    (!isResetFilter.value && (queuesChanged || allUnchanged)) ||
    props.isChangeGlobalStatus ||
    props.isChange
  );
});
// && props.selectedOptionsFilter.Projects.length == 0;

watch(
  () => props.isChangeGlobalStatus,
  (newValue) => {
    console.log('isChangeGlobalStatus', newValue);
  },
);

/**Переключение чекбокса элемента*/
const toggleItem = (item: OptionItemModel, type: OptionFilterEnum, isMultiSelect: boolean) => {
  emit('toggleItem', item, type, isMultiSelect);
};
/**Переключение чекбокса выбора всех элементов*/
const selectAllElements = (type: OptionFilterEnum, isMultiSelect: boolean) => {
  emit('selectAllElements', type, isMultiSelect);
};
/**Применить фильтр */
const applyFilter = () => {
  emit('setPreviousFilterValues', props.selectedOptionsFilter, props.filterOptions);
};
/**Отменить изменения в фильтре */
const cancelChangesFilter = () => {
  emit('cancelChangesFilter');
};
/**Сбросить фильтр */
const resetFilter = () => {
  emit('resetFilter');
  if (props.isApplyFilter) {
    isResetFilter.value = true;
  }
};
const onChangeProject = (value) => {
  //
  emit('getProjects', props.selectedOptionsFilter.Projects);
  emit('getProjects', value);
};
/**Получить статусы */
const getStatuses = (statuses: OptionItemModel[], isGlobalStatusChanged: boolean) => {
  emit('getStatuses', statuses, isGlobalStatusChanged);
};
</script>
<template>
  <div class="options-filter__block">
    <OptionItemFilter
      v-for="option in options"
      :option="option"
      :filterOptions="filterOptions"
      :selectedOptionsFilter="selectedOptionsFilter"
      :showOnlyCurrentIsAdmin="showOnlyCurrentIsAdmin"
      @getWidthBlockSelectedElem="emit('getWidthBlockSelectedElem', $event)"
      @searchElements="emit('searchElements', $event, option)"
      @scrollFinished="emit('scrollFinished', $event)"
      @getTagsProject="emit('getTagsProject', $event)"
      @getQueues="emit('getQueues', $event)"
      @getStatuses="getStatuses"
      @getNamespacesProject="emit('getNamespacesProject', $event)"
      @getProjects="onChangeProject"
      @toggleItem="toggleItem"
      @getDifficultys="emit('getDifficultys', $event)"
      @getTypesNamespace="emit('getTypesNamespace', $event)"
      @getPriorities="emit('getPriorities', $event)"
      @selectAllElements="selectAllElements"
    />
    <div class="options-filter__action-buttons">
      <div class="options-filter__apply-cancel-controls">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.PrimaryState"
          :size="TirPmButtonSizeEnum.Small"
          :isDisabled="isDisabledApply && !props.isChangeGlobalStatus && !props.isChange"
          @click="applyFilter"
        >
          Применить
        </TirPmButton>
        <TirPmButton
          :variant="TirPmButtonVariantEnum.SecondaryState"
          :size="TirPmButtonSizeEnum.Small"
          :isDisabled="isDisabledCancelFilter"
          @click="cancelChangesFilter"
        >
          Отмена
        </TirPmButton>
      </div>
      <div>
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          @click="resetFilter"
        >
          Сбросить фильтр
        </TirPmButton>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.options-filter {
  &__block {
    display: flex;
    flex-direction: column;
  }
  &__action-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem;
  }
  &__apply-cancel-controls {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
}
</style>
